<template>
  <section class="sequence-section">
    <sequence-review-info :associate="associate" />
    <a-checkbox :checked="checked" @change="$emit('change', $event)">
      I checked the associate information
    </a-checkbox>
    <p v-if="showValidation" class="validation-copy">Check the associate information to continue.</p>
  </section>
</template>

<script>
import { Checkbox } from 'ant-design-vue'
import SequenceReviewInfo from './sequence-review-info.vue'

export default {
  name: 'SequenceReviewAssociateCheck',
  components: {
    'a-checkbox': Checkbox,
    'sequence-review-info': SequenceReviewInfo
  },
  props: {
    associate: {
      type: Object,
      default: () => ({})
    },
    checked: {
      type: Boolean,
      default: false
    },
    showValidation: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.sequence-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.validation-copy {
  color: #ef4444;
}
</style>
